import { RootState } from "../Store";

export const SELECT_AGENT_BANKS_CHRONOLOGY_MODAL = (state: RootState) =>
  state.modalSlice.AgentBanksChronhologyModal;
export const SELECT_AGENT_CHRONOLOGY_MODAL = (state: RootState) =>
  state.modalSlice.AgentChronhologyModal;
export const SELECT_BANK_CHRONOLOGY_MODAL = (state: RootState) =>
  state.modalSlice.BankChronhologyModal;
